import script from "./dependents-incorporation-form-expired.vue?vue&type=script&setup=true&lang=js"
export * from "./dependents-incorporation-form-expired.vue?vue&type=script&setup=true&lang=js"

import "./dependents-incorporation-form-expired.vue?vue&type=style&index=0&id=2d4dd508&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4dd508"]])

export default __exports__